var chunkToChildrenMap = {
	"1351": [
		7639
	],
	"4120": [
		7639,
		2495
	],
	"5112": [
		109,
		6140
	],
	"5368": [
		7919,
		109,
		6140,
		5898
	],
	"6021": [
		7639,
		2495
	],
	"6685": [
		7639,
		2495
	],
	"8034": [
		7639,
		2495
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };